module.exports = __webpack_public_path__ + "static/media/sunarch_6.0beb0693.png";